"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapBoundsProvider = exports.MapBoundsContext = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const configContext_1 = require("./configContext");
const UserInfoContext_1 = require("./UserInfoContext");
exports.MapBoundsContext = (0, react_1.createContext)(undefined);
const MapBoundsProvider = props => {
    const configContext = (0, configContext_1.useConfig)();
    const { username } = (0, UserInfoContext_1.useUserInfo)();
    let lat = parseFloat(configContext.initialMapExtents.lat) || 0;
    let lon = parseFloat(configContext.initialMapExtents.lon) || 0;
    let zoom = configContext.initialMapExtents.zoom || 10;
    let mapcenter = undefined;
    let zoomlevel = undefined;
    let selectedFloorPlanId = undefined;
    try {
        mapcenter = localStorage.getItem(username + '-mapcenter');
        zoomlevel = localStorage.getItem(username + '-zoomlevel');
        selectedFloorPlanId = localStorage.getItem('recoil-selectedFloorPlanIdState'); // TODO: [S5-3775] Better way to handle the >90 bounds error on initial load?
    }
    catch (e) { }
    if (mapcenter && zoomlevel && !selectedFloorPlanId) {
        const persistedMapCenter = mapcenter.split(',');
        lat = persistedMapCenter[1];
        lon = persistedMapCenter[0];
        zoom = parseFloat(zoomlevel);
    }
    const [currentZoomLevel, setcurrentZoomLevel] = (0, react_1.useState)(zoom);
    const [mapCenter, setMapcenter] = (0, react_1.useState)([lon, lat]);
    const setCurrentZoomLevel = (0, react_1.useCallback)((zoomVal) => {
        try {
            localStorage.setItem(username + '-zoomlevel', zoomVal.toString());
        }
        catch (e) { }
        setcurrentZoomLevel(zoomVal);
    }, []);
    const setMapCenter = (0, react_1.useCallback)((center) => {
        try {
            localStorage.setItem(username + '-mapcenter', center.toString());
        }
        catch (e) { }
        setMapcenter(center);
    }, []);
    const value = (0, react_1.useMemo)(() => {
        return { currentZoomLevel, setCurrentZoomLevel, mapCenter, setMapCenter };
    }, [currentZoomLevel, setCurrentZoomLevel, mapCenter, setMapCenter]);
    return react_1.default.createElement(exports.MapBoundsContext.Provider, { value: value }, props.children);
};
exports.MapBoundsProvider = MapBoundsProvider;
//# sourceMappingURL=mapBoundsContext.js.map